import { Injectable } from '@angular/core';
import {
  DsconfigService,
  RestConnService
} from '@services/services.module';
import { Observable } from 'rxjs';

@Injectable()
export class ProjectsService {
  private projects_data: object;
  private All_projects_data: object;
  private project_data: object;
  private project_type: object;
  private client_all: object;
  private acivityType_all: object;
  private activityTypes_project: object;
  private employeeAsociated_project: object;
  private offices: object;
  private divisions: object;
  private projectAdd: object;
  private asociateEmployeeToProject: object;
  private classificationProject: object;
  private reactiveProject: object;

  constructor(
    private _res: RestConnService,
    private dsConfig: DsconfigService
  ) {
    this.projects_data = {
      'projects_data': dsConfig.getUrlBase() + '/ess/v1/employee/project'
    };
    this.All_projects_data = {
      'All_projects_data': dsConfig.getUrlBase() + '/ess/v1/project/all'
    };
    this.project_data = {
      'project_data': dsConfig.getUrlBase() + '/ess/v1/project/project'
    };
    this.project_type = {
      'project_type': dsConfig.getUrlBase() + '/ess/v1/projectType/all'
    };
    this.client_all = {
      'client_all': dsConfig.getUrlBase() + '/ess/v1/client/all'
    };
    this.acivityType_all = {
      'acivityType_all': dsConfig.getUrlBase() + '/ess/v1/activityType/all'
    };
    this.employeeAsociated_project = {
      'employeeAsociated_project': dsConfig.getUrlBase() + '/ess/v1/project/employees'
    };
    this.offices = {
      'offices': dsConfig.getUrlBase() + '/ess/v1/office/all'
    };
    this.divisions = {
      'divisions': dsConfig.getUrlBase() + '/ess/v1/division/active'
    };
    this.projectAdd = {
      'projectAdd': dsConfig.getUrlBase() + '/ess/v1/project'
    };
    this.asociateEmployeeToProject = {
      'asociateEmployeeToProject': dsConfig.getUrlBase() + '/ess/v1/project/associate/employees'
    };
    this.classificationProject = {
      'classificationProject': dsConfig.getUrlBase() + '/ess/v1/clasificationProject/all'
    };
  }

  getProjects(intEmpId: number) {
    return this._res.get('projects_data', { intEmpId: intEmpId },
      {
        collection: this.projects_data
      }
    );
  }

  getAllProjects() {
    return this._res.get('All_projects_data', {},
      {
        collection: this.All_projects_data
      }
    );
  }

  getDataProject(intProId) {
    return this._res.get('project_data', { intProId: intProId },
      {
        collection: this.project_data
      }
    );
  }

  getTypeProject() {
    return this._res.get('project_type', {},
      {
        collection: this.project_type
      }
    );
  }

  getAllClients() {
    return this._res.get('client_all', {},
      {
        collection: this.client_all
      }
    );
  }

  getAllActivityType() {
    return this._res.get('acivityType_all', {},
      {
        collection: this.acivityType_all
      }
    );
  }

  getActivityTypesFromProject(intTipactId) {
    return this._res.get('activityTypes_project', { intTipactId: intTipactId },
      {
        collection: this.activityTypes_project
      }
    );
  }

  getEmployeeAsociatedProject(idProject) {
    return this._res.get('employeeAsociated_project', { idProject: idProject },
      {
        collection: this.employeeAsociated_project
      }
    );
  }

  postAsociateEmployeesToProject(item: any) {
    return this._res
      .post('asociateEmployeeToProject', item,
        {
          collection: this.asociateEmployeeToProject
        }
      );
  }

  getOffices() {
    return this._res.get('offices', {},
      {
        collection: this.offices
      }
    );
  }

  getDivisions(): Observable<any> {
    return this._res.get('divisions', {},
      {
        collection: this.divisions
      }
    );
  }

  getClassificacionProjects(): Observable<any> {
    return this._res.get('classificationProject', {},
      {
        collection: this.classificationProject
      }
    );
  }

  addProject(project: any): Observable<any> {
    this.projectAdd = {
      'projectAdd': this.dsConfig.getUrlBase() + '/ess/v1/project'
    };
    if (!!project.intProId) {
      return this._res.put('projectAdd', project,
        {
          collection: this.projectAdd
        });
    } else {
      delete project.intProId;
      return this._res.post('projectAdd', project,
        {
          collection: this.projectAdd
        }
      );
    }
  }

  putreactiveProject(projectId: number): Observable<any> {
    this.reactiveProject = {
      'reactiveProject': this.dsConfig.getUrlBase() + '/ess/v1/project/endDate'
    };
    return this._res.put('reactiveProject', { projectId },
      {
        collection: this.reactiveProject
      }
    );
  }
}
